<div class="dialog-header header-simple">
  <h2 mat-dialog-title>
    {{ 'createDoc.signersDialog.title' | transloco }}
  </h2>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="form">
  <mat-dialog-content>
    <section class="section">
      <label class="field-label" for="managingDirectorSelect">
        {{ 'createDoc.signersDialog.managingDirectorLabel' | transloco }}
        <span class="required">*</span>
      </label>
      <div class="field-wrapper">
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            id="managingDirectorSelect"
            formControlName="managingDirector"
            [matAutocomplete]="managingDirectorAuto"
            [placeholder]="'common.buttons.search' | transloco" />
          <mat-autocomplete #managingDirectorAuto="matAutocomplete" [displayWith]="displayPerson">
            <mat-option *ngFor="let p of filteredManagingDirectors" [value]="p"> {{ p.firstName }} {{ p.lastName }} </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.get('managingDirector')?.hasError('required')">
            {{ 'createDoc.signersDialog.managingDirectorRequired' | transloco }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="info-hint">
        <mat-icon color="primary" inline>info</mat-icon>
        @if (canManageProfiles) {
          <span>
            {{ 'createDoc.signersDialog.managingDirectorHintPre' | transloco }}
            <a (click)="clickOrganisationSettings()">
              {{ 'createDoc.signersDialog.managingDirectorHintLink' | transloco }}
            </a>
            {{ 'createDoc.signersDialog.managingDirectorHintPost' | transloco }}
          </span>
        } @else {
          <span>{{ 'createDoc.createDocDialog.profilesManagedByAdmin' | transloco }}</span>
        }
      </div>
      <div *ngIf="selectedManagingDirector" class="person-card">
        <div class="person-icon">
          <mat-icon>person</mat-icon>
        </div>
        <div class="person-details">
          <div class="person-name">
            {{ selectedManagingDirector.firstName }}
            {{ selectedManagingDirector.lastName }}
          </div>
          <div>{{ selectedManagingDirector.email }}</div>
          <div>{{ selectedManagingDirector.phoneNumber }}</div>
        </div>
      </div>
      <div *ngIf="!selectedManagingDirector" class="person-card empty-card">
        <div class="person-icon warn">
          <mat-icon>warning</mat-icon>
        </div>
        <div class="person-details">
          <div class="person-name">{{ 'createDoc.signersDialog.noManagingDirectorSelected' | transloco }}</div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <div>
          <h3 class="section-title">
            {{ 'createDoc.signersDialog.otherSignerTitle' | transloco }}
          </h3>
          <p class="section-subtitle">
            {{ 'createDoc.signersDialog.otherSignerSubtitle' | transloco }}
          </p>
        </div>
        <mat-slide-toggle formControlName="hasOtherSigner" color="primary"> </mat-slide-toggle>
      </div>
      <ng-container *ngIf="form.value.hasOtherSigner">
        <label class="field-label" for="signerSelect">
          {{ 'createDoc.signersDialog.otherSignerLabel' | transloco }}
        </label>
        <div class="field-wrapper">
          <mat-form-field appearance="outline" class="full-width">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              id="signerSelect"
              formControlName="signer"
              [matAutocomplete]="signerAuto"
              [placeholder]="'common.buttons.search' | transloco" />
            <mat-autocomplete #signerAuto="matAutocomplete" [displayWith]="displayPerson">
              <mat-option *ngFor="let p of filteredSigners" [value]="p"> {{ p.firstName }} {{ p.lastName }} · {{ p.function }} </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="form.get('signer')?.hasError('required')">
              {{ 'dataManagement.organizationSettings.validation.signerRequired' | transloco }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="info-hint">
          <mat-icon color="primary" inline>info</mat-icon>
          @if (canManageProfiles) {
            <span>
              {{ 'createDoc.signersDialog.otherSignerHintPre' | transloco }}
              <a (click)="clickOrganisationSettings()">
                {{ 'createDoc.signersDialog.otherSignerHintLink' | transloco }}
              </a>
              {{ 'createDoc.signersDialog.otherSignerHintPost' | transloco }}
            </span>
          } @else {
            <span>{{ 'createDoc.createDocDialog.profilesManagedByAdmin' | transloco }}</span>
          }
        </div>
        <div *ngIf="selectedSigner" class="person-card">
          <div class="person-icon">
            <mat-icon>edit</mat-icon>
          </div>
          <div class="person-details">
            <div class="person-name">{{ selectedSigner.firstName }} {{ selectedSigner.lastName }}</div>
            <div>{{ selectedSigner.function }}</div>
            <div>{{ selectedSigner.email }}</div>
            <div>{{ selectedSigner.phoneNumber }}</div>
          </div>
        </div>
        <div *ngIf="!selectedSigner" class="person-card empty-card">
          <div class="person-icon warn">
            <mat-icon>warning</mat-icon>
          </div>
          <div class="person-details">
            <div class="person-name">{{ 'createDoc.signersDialog.noSignerSelected' | transloco }}</div>
          </div>
        </div>
      </ng-container>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onContinue()">
      {{ 'common.buttons.confirm' | transloco }}
    </button>
  </mat-dialog-actions>
</form>
